/* 🤖 this file was generated by svg-to-ts */
export const siriusLockSimpleOpenDuotone: {
  name: 'lock_simple_open_duotone';
  data: string;
} = {
  name: 'lock_simple_open_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M19.5 8.25h-15a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.144 3.019a2.625 2.625 0 0 1 4.481 1.856.75.75 0 0 0 1.5 0 4.125 4.125 0 0 0-8.25 0V7.5H4.5A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5H9.375V4.875c0-.696.277-1.364.769-1.856ZM4.5 9v10.5h15V9h-15Z" fill="currentColor"/></svg>`
};
